export const OfferUnsubscribeErrorViewMessages = {
  errorMessage: {
    id: 'Pages.OfferUnsubscribeError.View.errorMessage',
    description: 'Offer Unsubscribe Error Message',
  },
}
